<p-confirmPopup></p-confirmPopup>
<div class="activity-outer basic-tabs common-booking-payment treetable
">
    <p-treeTable id="tbl-booking" [lazy]="true" [scrollable]="true"
        [tableStyle]="bookingList?.length === 0 ? { 'min-width': '3500px' } : {}" [value]="bookingList"
        (onNodeExpand)="onNodeExpand($event)" (onNodeCollapse)="onNodeCollapse($event)">
        <ng-template pTemplate="togglericon" let-expanded>
            <em *ngIf="expanded" class="pi pi-minus"></em>
            <em *ngIf="!expanded" class="pi pi-plus"></em>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th scope="col">Parking Lot</th>
                <th scope="col" class="ptable-access">Access Code</th>
                <th scope="col">Spot(s)</th>
                <th scope="col">Arrival & Departure</th>
                <th scope="col">Time Zone</th>
                <th scope="col">Last Updated On</th>
                <th scope="col" class="ptable-custom-inno">Invoice Number</th>
                <th scope="col" *ngIf="activeIndex === 3">Billing Cycle</th>
                <th scope="col" class="common-schedule">Upcoming Schedule</th>
                <th scope="col" *ngIf="isGroupUser">Spot Count</th>
                <th scope="col" class="ptable-custom-amount">Amount ($)</th>
                <th scope="col" class="ptable-paymentmode">Payment Mode</th>
                <th scope="col" class="ptable-paymentmode">Payment Status</th>
                <th scope="col">Refunded ($)</th>
                <th scope="col">Custom Refund ($)</th>
                <th scope="col">Booking Status</th>
                <th scope="col" *ngIf="activeIndex === 3">Cancellation Reason</th>
                <th scope="col" class="custom-action">Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-product>
            <tr [ttRow]="rowNode" [ngClass]="{'expanded-node': isExpanded(product.node), 
            'expanded-child': isChildExpanded(product.node)}">
                <td>
                    <div class="treetoggle">
                        <p-treeTableToggler [rowNode]="rowNode" *ngIf="activeIndex !== 0">
                            <ng-template pTemplate="togglericon" let-expanded>
                                <em *ngIf="expanded" class="pi pi-minus"></em>
                                <em *ngIf="!expanded" class="pi pi-plus"></em>
                            </ng-template>
                        </p-treeTableToggler>

                        <div class="custom-name" (click)="navigateToBookingDetails(product.node)">
                            <div class="img-inner">
                                <img class="circle-img" [src]="(product.node?.companyLogo) || dummy"
                                    alt="Company logo" />
                            </div>
                            <div class="custom-text common-custom-text">
                                <h5>{{product.node.parkingLotName}}</h5>
                                <p>{{product.node?.location || product.node?.parkingLotAddress}}</p>
                            </div>
                        </div>
                    </div>
                </td>
                <td class="big-parking ptable-access">
                    {{ product.node.isOpenGateIntegarted || (!product.node.isOpenGateIntegarted && product.node?.status
                    ===
                    'Cancelled')? '-' : product.node.accessCode}}
                </td>
                <td class="big-parking">
                    <div class="spots-cell">
                        <ng-container *ngIf="!hasSpotOverflow(product.node); else spotOverflow">
                            <h5>{{ getAssignedSpotsDisplay(product.node) }}</h5>
                        </ng-container>
                        <ng-template #spotOverflow>
                            <h5>
                                {{ getAssignedSpotsPreview(product.node) }}
                                <button
                                    type="button"
                                    class="spots-toggle"
                                    aria-label="Toggle spot list"
                                    (click)="toggleSpots(product.node)">
                                    ...
                                </button>
                            </h5>
                            <div *ngIf="isSpotsExpanded(product.node)" class="spots-expanded">
                                <h5 *ngFor="let line of getAssignedSpotsOverflowLines(product.node)">{{ line }}</h5>
                            </div>
                        </ng-template>
                    </div>
                </td>
                <td *ngIf="(activeIndex === 3)&& !rowNode.node.parent  else oneTimeEnddate">
                    <div class="big-parking">
                        <h5>{{(product.node.startDate | luxonFormat) }}</h5>
                        <p>{{(product.node.isSubscriptionCancel) ? (product.node.endDate | luxonFormat) : '-' }}</p>
                    </div>
                </td>
                <ng-template #oneTimeEnddate>
                    <td>
                        <div class="big-parking">
                            <h5>{{(product.node.startDate | luxonFormat) }}</h5>
                            <p>{{(product.node.endDate | luxonFormat ) }}</p>
                        </div>
                    </td>
                </ng-template>
                <td class="big-parking">
                    <h5>{{product?.node?.timeZone? getTimeZoneAbbreviation(product.node.timeZone): '-'}}</h5>
                </td>
                <td>{{ product.node.lastUpdatedOn ? (product.node.lastUpdatedOn | luxonFormat) : '-' }}
                </td>
                <td class="ptable-custom-inno">{{product.node.invoiceNumber}}</td>
                <td *ngIf="activeIndex === 3">
                    <div class="custom-text recurring-outer">
                        <h5>{{product.node.recurringCount}}</h5>
                        <p class="recurring-cancelled" *ngIf="product.node.isSubscriptionCancel" class="payment-failed">
                            Recurring
                            Cancelled on {{product.node.recurringCancelDate | date:'MMM d, yyyy'}}</p>
                        <p class="recurring-active">
                            {{showActiveRecurring(product.node)}}</p>
                    </div>
                </td>
                <td class="common-schedule"
                    *ngIf="product.node.bookingScheduledDate !=null && product.node.bookingScheduledAction !=null;else noUpcomingSchedule">
                    <div class="custom-text recurring-outer common-custom-text">
                        <h5>{{product.node.bookingScheduledAction || '-'}}</h5>
                        <p class="recurring-cancelled">{{product.node.bookingScheduledDate || '-'}}</p>
                    </div>
                </td>
                <ng-template #noUpcomingSchedule>
                    <td class="common-schedule">
                        <div class="custom-text recurring-outer">
                            <h5>-</h5>
                        </div>
                    </td>
                </ng-template>
                <td ptable-custom-amount *ngIf="isGroupUser">{{product.node.spotCount}}</td>
                <td class="ptable-custom-amount">
                    <div class="big-parking">
                        <h5>{{product.node.total || product.node?.total}}</h5>
                    </div>
                </td>
                <td class="ptable-paymentmode">
                    {{product.node.bookingPaymentMode | paymentModeValue }}
                </td>
                <td class="ptable-paymentmode">
                    <div class="big-parking common-payment-status">
                        <p [ngClass]="product.node.paymentStatus | PaymentStatusClass">
                            {{product.node.label}}</p>
                        <span class="payment-tooltip"
                            *ngIf="product.node.paymentStatus === paymentStatusForMessage.Failure">
                            <em class="pi pi-info-circle"
                                [pTooltip]="product.node?.paymentFailureError || product.node?.failureDescription"
                                tooltipPosition="top"></em>
                        </span>
                    </div>
                </td>
                <td>
                    <div class="big-parking">
                        <h5>{{product.node.refundAmount || '-'}}</h5>
                        <p *ngIf="product.node.refundDate || product.node.partialStatusUpdatedate">
                            {{ (product.node.refundDate || product.node.partialStatusUpdatedate) | luxonFormat }}
                        </p>
                    </div>
                </td>
                <td>
                    {{product.node.bookingCustomRefundAmount || '-'}}
                </td>
                <td>
                    <div class="big-parking">
                        <h5 class="paid-text-border">
                            <div class="common-status" [ngClass]="product.node.status | BookingStatusClass">
                                {{product.node.status}}
                            </div>
                        </h5>
                    </div>
                </td>
                <td *ngIf="activeIndex === 3">

                    <div class="custom-text cancellation-reason-outer">
                        <em class="pi pi-info-circle" *ngIf="product.node.cancellationReasonDetail"
                            [pTooltip]="product.node?.cancellationReasonDetail" tooltipPosition="top">
                        </em>
                        <p>{{product.node.cancellationReason || '-'}}</p>
                    </div>
                </td>
                <td class="custom-action">
                    <div class="action-item">
                        <div class="export-btn" (click)="showData(product.node,$event);menu.toggle($event)">
                            <img src="assets/images/dot.svg" alt="" />
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
            <tr class="no-inner">
                <td class="no-record" colspan="7">
                    There are no bookings yet!
                </td>
            </tr>
        </ng-template>
    </p-treeTable>
</div>
<div class="card common-content-end custom-pagination1" *ngIf="bookingList?.length > 0">
    <p-paginator [rows]="itemsPerPage" [first]="BookingCurrentSkip" [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"></p-paginator>

</div>
<div class="custom-export"><p-menu #menu [model]="items" [popup]="true"></p-menu></div>
<ng-template #drawerHost></ng-template>